import styled from 'styled-components'

export const LayoutWrapper = styled.div`
  height: 100%;
  position: relative;
`

export const PageWrapper = styled.div`
  background: var(--Warm-White);
  position: relative;
`

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: visible;
  position: relative;
  .page {
    top: 0;
    width: 100%;
    height: 100%;
  }
  .page.entering,
  .page.entered {
    opacity: 1;
    transition: opacity 1s 0.2s;
    position: relative;
  }
  .page.exiting,
  .page.exited {
    position: absolute;
    opacity: 0;
    transition: opacity 0s;
  }
`
